import { render, staticRenderFns } from "./HubContactsGroupsDetail.vue?vue&type=template&id=3dc6b60d&"
import script from "./HubContactsGroupsDetail.vue?vue&type=script&lang=js&"
export * from "./HubContactsGroupsDetail.vue?vue&type=script&lang=js&"
import style0 from "./HubContactsGroupsDetail.vue?vue&type=style&index=0&id=3dc6b60d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports